export default {
  createStudyMaterial: "/studyMaterial/createStudyMaterial",
  getStudyMaterial: "/studyMaterial/getStudyMaterial",
  editStudyMaterial: "/studyMaterial/editStudyMaterial",
  deleteStudyMaterial: "/studyMaterial/deleteStudyMaterial",
  getSignedUrl: "/spaces/presigned_url"
};
